"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _convertHexToRgba = _interopRequireDefault(require("@kiwicom/orbit-design-tokens/lib/convertHexToRgba"));

var _consts = require("../consts");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getButtonLinkBoxShadow = function getButtonLinkBoxShadow(state) {
  return function (_ref) {
    var disabled = _ref.disabled,
        theme = _ref.theme,
        transparent = _ref.transparent;

    if (disabled) {
      return null;
    }

    if (state === _consts.BUTTON_STATES.ACTIVE && !transparent) {
      return (0, _styledComponents.css)(["box-shadow:inset 0 0 6px 3px ", ";"], (0, _convertHexToRgba.default)(theme.orbit.paletteInkNormal, 8));
    }

    if (state === _consts.BUTTON_STATES.FOCUS) {
      return (0, _styledComponents.css)(["", ";"], !transparent && (0, _styledComponents.css)(["&:active{box-shadow:inset 0 0 6px 3px ", ";}"], (0, _convertHexToRgba.default)(theme.orbit.paletteInkNormal, 8)));
    }

    return null;
  };
};

var _default = getButtonLinkBoxShadow;
exports.default = _default;